import styled from 'styled-components'
import { widthResize, widthFull, heightHeader, primaryGradient, boxShadow } from '../Resources/Theme'

const Header = styled.header`
  position: fixed;
  height: ${heightHeader};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  left: ${props => props.resize ? widthResize : widthFull};
  box-shadow: none;
  border-bottom: 1px solid #e8edf3;
  background: rgba(248, 250, 252, .92);
  backdrop-filter: blur(18px);
  transition: .3s ease;
  padding: 0 32px;
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(260px, 480px) auto;
  align-items: center;
  z-index: 40;
  
  @media (max-width: 992px) {
    left: 0;
    width: 100%;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 0 18px;
  }
`

Header.Left = styled.div`
  height: ${heightHeader};
  display: none;
  text-align: center;
  color: #0f172a;

  @media (max-width: 992px) {
    width: 33%;
    display: flex;
  }
`

Header.Brand = styled.div`
  display: none;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    align-self: center;
    justify-content: center;
    display: flex;
  }
`

Header.Brand.Logo = styled.img`
  @media (max-width: 992px) {
    max-height: 40px;
  }
`

Header.Right = styled.div`
  height: ${heightHeader};
  display: flex;
  justify-content: flex-end;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    width: 100%;
  }
`

Header.Right.Icon = styled.div`
  height: ${heightHeader};
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25rem;
  color: #475569;
  cursor: pointer;

  &:hover {
    color: #4f46e5;
    background-color: #eef2ff;
    border-radius: 12px;
  }

  @media (max-width: 992px) {
    width: 40px;
  }
`

Header.Right.Image = styled.img`
  border-radius: ${props => props.maxHeight ? props.maxHeight : '12px'};
  height: ${props => props.maxHeight ? props.maxHeight : '45px'};
  width: ${props => props.maxHeight ? props.maxHeight : '50px'};
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #e2e8f0, 0 6px 16px rgba(15,23,42,.12);
`

export default Header
